import script from "./CsPortfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./CsPortfolio.vue?vue&type=script&setup=true&lang=js"

import "./CsPortfolio.vue?vue&type=style&index=0&id=3be5c6db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be5c6db"]])

export default __exports__